module.exports = __webpack_public_path__ + "static/media/Sort A-z-Selected.ff02cf16.svg";